export enum ECoursesQueryKeys {
  getAllCourses = "getAllCourses",
  getCourseById = "getCourseById",
  getAllCourseLessons = "getAllCourseLessons",
  getCourseLessonById = "getCourseLessonById",
  getAllCourseLessonChapters = "getAllCourseLessonChapters",
  getCourseLessonChapterById = "getCourseLessonChapterById",
}

export const COURSES_ENDPOINTS = {
  COURSES: "/materials/courses",
  COURSE_LESSONS: (courseId: string) =>
    `/materials/courses/${courseId}/lessons`,
  ADD_LESSON_TO_GROUP: (courseId: string, lessonId: string) =>
    `/materials/courses/${courseId}/lessons/${lessonId}/add-to-group`,
  REMOVE_LESSON_FROM_GROUP: (courseId: string, lessonId: string) =>
    `/materials/courses/${courseId}/lessons/${lessonId}/remove-from-group`,
  ADD_COURSE_TO_GROUP: (courseId: string) =>
    `/materials/courses/${courseId}/add-to-group`,
  REMOVE_COURSE_FROM_GROUP: (courseId: string) =>
    `/materials/courses/${courseId}/remove-from-group`,
};
